import { Box } from '@chakra-ui/react';
import { cloudinary } from 'lib/cloudinary';
import { useEffect, useRef } from 'react';

/* INFO: Serve both encodes untransformed rather than via Cloudinary's f_auto,
 * which defaults to H264 (no alpha). Transparency needs HEVC-alpha (Safari)
 * and VP9-alpha (Chrome/Firefox) — hence the two explicit sources. */
const PROMO_HEVC = cloudinary.video('constants/video/promo--hevc').toURL();
const PROMO_VP9 = cloudinary.video('constants/video/promo--vp9').toURL();

export const SkincareVideo = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.playsInline = true;

      const playVideo = async () => {
        await videoRef.current?.play();
      };

      playVideo();
    }
  }, []);

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      sx={{
        video: {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'center',
          '@media (max-width: 1200px)': {
            objectFit: 'cover',
          },
        },
      }}
    >
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        aria-label="Timeline skincare promotional video"
      >
        <source src={PROMO_HEVC} type="video/mp4; codecs=hvc1" />
        <source src={PROMO_VP9} type="video/webm" />
      </video>
    </Box>
  );
};
